<template>
  <el-header class="media-768-header">
    <el-row>
      <el-col class="media-768-con" :span="16">
        <a href="../" class="media-768-logo">
          <img src="../../assets/image/contact_logo.png" alt="" />
        </a>
        <el-dropdown trigger="click" @command="handleCommand">
          <div class="menu-click">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="index_1" :style="pathName === '/Research' ? 'color:#4063F9;' : ''">Research
            </el-dropdown-item>
            <el-dropdown-item command="index_2" :style="pathName === '/People' ? 'color:#4063F9;' : ''">People
            </el-dropdown-item>
            <el-dropdown-item command="index_3" :style="pathName === '/Science' ? 'color:#4063F9;' : ''">Science And
              Art</el-dropdown-item>
            <el-dropdown-item command="index_4" :style="pathName === '/Joinus' ? 'color:#4063F9;' : ''">Join Us
            </el-dropdown-item>
            <el-dropdown-item command="index_5" :style="pathName === '/Contactus' ? 'color:#4063F9;' : ''">Contact Us
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
      <el-col :span="8">
        <a class="menu-toContact">
          <div>
            <span>{{ titleName }}</span>
            <div class="titleIcon">
              <img src="../../assets/image/contact_media.png" alt="" />
            </div>
          </div>
        </a>
      </el-col>
    </el-row>
  </el-header>
</template>

<script>
export default {
  name: "mediaHeader",
  data() {
    return {
      titleName: "",
      titleIndex: [
        {
          title: "Research",
          key: "Research",
          selected: true,
        },
        {
          title: "People",
          key: "People",
        },
        {
          title: "Science And Art",
          key: "Science",
        },
        {
          title: "Join Us",
          key: "Joinus",
        },
        {
          title: "Contact Us",
          key: "Contactus",
        },
      ],
      // 绑定页面初始化的pathName
      pathName: ''
    };
  },
  created() { 
    this.pathName = window.location.pathname
    console.log(this.pathName)
    if (this.pathName === '/') {
      this.titleName = 'Index'
    } else if (this.pathName === '/Research') {
      this.titleName = 'Research'
    } else if (this.pathName === '/People') {
      this.titleName = 'People'
    } else if (this.pathName === '/Science') {
      this.titleName = 'Science'
    } else if (this.pathName === '/Joinus') {
      this.titleName = 'Joinus'
    } else if (this.pathName === '/Contactus') {
      this.titleName = 'Contactus'
    }
  },
  mounted() {
  },
  methods: {
    handleCommand(command) {
      if (command === "index_1") {
        this.$router.push('../Research')
      } else if (command === "index_2") {
        this.$router.push('../People')
      } else if (command === "index_3") {
        this.$router.push('../Science')
      } else if (command === "index_4") {
        this.$router.push('../Joinus')
      } else if (command === "index_5") {
        this.$router.push('../Contactus')
      }
    },
  },
};
</script>


<style scoped>
/* 当设备尺寸缩放到768px时，此组件才会生效 */
@media screen and (max-width: 768px) {
  img {
    width: 100%;
    height: 100%;
  }

  /*elementUI 更改弹框样式*/
  .el-dropdown-menu {
    box-sizing: border-box;
    width: 66.5%;
    left: 0 !important;
    top: 60px !important;
    border: none;
    border-radius: 0;
    opacity: 0.92;
    margin: 0;
    padding: 0;
  }

  .el-dropdown-menu__item {
    margin: 0 auto;
    width: 85%;
    line-height: 51px;
    color: #4d4d4d;
    text-align: center;
    border-bottom: 1px solid #8c9090;
    box-sizing: border-box;
  }

  .el-dropdown-menu__item:nth-child(5) {
    border-bottom: none;
  }

  .media-768-header {
    padding: 0;
    display: block;
    width: 100%;
    height: 60px !important;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    box-shadow: 0 1px 10px -6px rgba(0, 0, 0, 0.8);
  }

  .media-768-header>.el-row {
    height: 100%;
    display: flex;
  }

  .media-768-con {
    display: flex;
    height: 100%;
    padding: 0 42px 0 30px;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border-right: 1.5px solid #000;
  }

  .media-768-logo {
    display: block;
    width: 70px;
    height: 34px;
  }

  .menu-click {
    width: 28.5px;
    height: 17.5px;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
  }

  .menu-click>div {
    width: 100%;
    height: 2.5px;
    background-color: #4063f9;
    border-radius: 2.5px;
  }

  .menu-toContact>div {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  .menu-toContact>div>div:nth-child(2) {
    width: 16px;
    height: 16px;
    padding: 0 0 7px 10px;
  }

  .titleIcon img {
    padding-top: 5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/media/mediaHeaderPeo.vue